export const formEl = [
    {
        label: 'Resposta Curta',
        value: 'text'
    },
    {
        label: 'Resposta Longa',
        value: 'textarea'
    },
    {
        label: 'Opção Única',
        value: 'radio'
    },
    {
        label: 'Escolha Múltipla',
        value: 'checkbox'
    },
    {
        label: 'Escala',
        value: 'scale'
    }
];
